__webpack_require__.p = "/global/assets/favourites/_next/";